module.exports = __webpack_public_path__ + "static/media/packed_solution2.8c2b451a.gif";